import IndicesDialog from './IndicesDialog';
export default IndicesDialog;